module.exports = __webpack_public_path__ + "static/media/starFull.1f72204f.svg";